import { useEffect, useState } from 'react'
import type { SupabaseClient } from '@supabase/supabase-js'
import { PAYS_PAR_DEFAUT, lirePaysDefaut } from './api'
import type { ValeurTelephone } from './ChampTelephone'

/**
 * État d'un champ « numéro » de formulaire : démarre vide, avec le pays de configuration de la console
 * (`lirePaysDefaut` : dernier pays utilisé, sinon pays de l'organisation opératrice, jamais écrit en dur).
 * Le pays n'est remplacé que tant que rien n'a été saisi.
 */
export function useTelephone(client: SupabaseClient): { valeur: ValeurTelephone; setValeur: (v: ValeurTelephone) => void } {
  const [valeur, setValeur] = useState<ValeurTelephone>({ texte: '', iso: PAYS_PAR_DEFAUT })
  useEffect(() => {
    let vivant = true
    void lirePaysDefaut(client).then((p) => vivant && setValeur((v) => (v.texte ? v : { ...v, iso: p.iso })))
    return () => {
      vivant = false
    }
  }, [client])
  return { valeur, setValeur }
}
